'use strict';

require('./performance-review-agreement-questionnaire.scss');

module.exports = {
  template: require('./performance-review-agreement-questionnaire.html'),
  controller: require('./performance-review-agreement-questionnaire.controller'),
  controllerAs: 'vm',

  bindings: {
    token: '<',
    step: '<',
    data: '<',
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-agreement-questionnaire/index.js
 ** module id = 292
 ** module chunks = 0
 **/